/**
 * @Author Valon.Ye
 * @Date 2022/09/08 17:10:59
 * @FilePath \business\src\utils\redirect.ts
 * @Description
 */
import { history } from 'umi'
import type {
  SetBusinessUserOrganizationResponse,
  OrganizationResponse,
} from '@/api-auto-gen/authentication'
import type { UserProfileResponse } from '@/api-auto-gen/organization'

const COMMERCE_INDEX = '/order-management'

const MESSAGING_INDEX = '/ssm/customer-management/unified-profile/all-individuals'

const CRM_INDEX = '/platform/setup/home/platform-tools/crm-settings/org-connection'

export const redirectCommerce = () => {
  window.location.href = COMMERCE_INDEX
}

export const redirectMessaging = () => {
  window.location.href = MESSAGING_INDEX
}

export const pushToCommerce = () => {
  history.push(COMMERCE_INDEX)
}

export const redirectToCrm = () => {
  window.location.href = CRM_INDEX
}

export type IAssetToken =
  | SetBusinessUserOrganizationResponse
  | OrganizationResponse
  | UserProfileResponse

const getAppAssetEnabled = (data: IAssetToken) => {
  const isCommerceEnabled = data.asset_cnde_enabled || data.asset_ssc_enabled
  const isMessagingEnabled = data.asset_cnde_enabled || data.asset_ssm_enabled
  const isCrmEnabled = data.asset_cnde_enabled || data.asset_crm_enabled

  return {
    isCommerceEnabled,
    isMessagingEnabled,
    isCrmEnabled,
  }
}

const redirectToApp = (data: IAssetToken) => {
  const { isCommerceEnabled, isMessagingEnabled, isCrmEnabled } = getAppAssetEnabled(data)

  if (isCommerceEnabled) {
    return [data.asset_ssc_id, redirectCommerce] as const
  }
  if (isMessagingEnabled) {
    return [data.asset_ssm_id, redirectMessaging] as const
  }
  if (isCrmEnabled) {
    return [data.asset_crm_id, redirectToCrm] as const
  }
  return [undefined, () => {}] as const
}

const pushToApp = (data: IAssetToken) => {
  const { isCommerceEnabled, isMessagingEnabled, isCrmEnabled } = getAppAssetEnabled(data)

  if (isCommerceEnabled) {
    return [data.asset_ssc_id, pushToCommerce] as const
  }
  if (isMessagingEnabled) {
    return [data.asset_ssm_id, redirectMessaging] as const
  }
  if (isCrmEnabled) {
    return [data.asset_crm_id, redirectToCrm] as const
  }
  return [undefined, () => {}] as const
}

/**
 * @author: Valon.Ye
 * @description:
 * @param {IAssetToken} data
 * @param {function} cb cb调用之后app会进行对应的跳转，请保证cb中的执行是必要的持久化操作，避免数据丢失
 * @return {*}
 */
const redirect = (data: IAssetToken, cb: () => void) => {}

export { redirectToApp, pushToApp }
